import { NOTIFICATION_CLEAR, NOTIFICATION_SET } from "../store/config";

const notificationInit = {
	data: {title: null, content: null, type: null},
	active: false,
	timestamp: null
}

const notifications = (state = notificationInit, action) => {
	switch(action.type) {
		case NOTIFICATION_SET:
			return {
				...state,
				data: action.data,
				active: action.active,
				timestamp: action.timestamp
			}
		case NOTIFICATION_CLEAR:
			return {
				...state,
				data: action.data,
				active: action.active,
				timestamp: action.timestamp
			}
		default:
			return {
				...state
			}
	}
}

export default notifications;


// WEBPACK FOOTER //
// ./src/reducers/notifications.js